// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272.5%27 fill=%27%232E6B9B%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The app's own stylesheet, in the same \`app\` cascade layer as Bootstrap.
 *
 * Wrapped as a whole rather than reindented, so the diff stays readable. Being
 * in Bootstrap's layer -- rather than unlayered -- keeps the two in exactly the
 * relationship they have always had (same layer: source order and specificity
 * decide), while letting Tailwind's layers, which come after, reach the
 * shadcn/ui components. See docs/STYLING.md.
 */
@layer app {

:root {
  --bs-nav-active-bg: rgba(0, 0, 0, 0.1);
  --green-800: #34571D;
  --green-700: #3E6C1F;
  --green-600: #477F1F;
  --green-400: #87cd4e;
  --green-300: #a8de78;
  --green-200: #CAECAA;
  --green-100: #E4F5D2;
  --blue-800: #254e6f;
  --blue-700: #26567E;
  --blue-600: #2E6B9B;
  --blue-400: #63A3CD;
  --blue-300: #99c2e0;
  --blue-200: #C9DDEE;
  --blue-100: #D6E6F2;
  --blue-50: #F3F7FC;
  --red-800: #9B1E09;
  --red-700: #B71b06;
  --red-600: #F2250A;
  --red-500: #FF4320;
  --red-400: #FF7755;
  --red-200: #FFD0BE;
  --red-100: #FFE6DB;
  --pink-900: #811a3f;
  --pink-600: #d82a71;
  --pink-300: #f8a9d1;
  --orange-800: #9c3910;
  --orange-600: #ee6108;
  --orange-300: #ffc072;
  --yellow-900: #722F15;
  --yellow-700: #A25711;
  --yellow-600: #C08F0E;
  --yellow-500: #E0B114;
  --yellow-400: #F0D333;
  --yellow-200: #F8F190;
  --yellow-100: #FBFAC6;
  --neutral-50: #F8F8F8;
  --neutral-100: #F1F0EF;
  --neutral-200: #E6E4E2;
  --neutral-300: #D9D6D4;
  --neutral-400: #B9B4B0;
  --neutral-500: #9f9894;
  --neutral-600: #87807B;
  --neutral-800: #5E5956;
  --neutral-700: #706965;
  --neutral-600: #87807B;
  --neutral-950: #292726;
  --neutral-900: #514D4B;
  --gray-600: #6C757D
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Page-level heading. Continues the -0.02em tracking scale the card titles use
   (18px/-0.36px, 12px/-0.24px). Margin is zeroed so the page container owns the spacing. */
.page-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--neutral-950);
  letter-spacing: -0.48px;
  line-height: 1.2;
  margin: 0;
}

.w-95 {
  width: 95% !important;
}

.max-w-75 {
  max-width: 75% !important;
}

/* Lets a flex item shrink below its content width (e.g. so text-truncate works). */
.min-w-0 {
  min-width: 0 !important;
}

.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.nav-tabs .nav-item .nav-link {
  background-color: rgba(33, 37, 41, 0.03);
  color: black;
}

.nav-tabs .nav-item .nav-link.active {
  background-color: white;
}

.modal-fixed-width {
  width: 80vw;
  max-width: 80vw;
}

.modal-body-fixed {
  display: flex;
  flex-direction: column;
  height: 80vh;
  overflow: scroll;
}

.nested-modal-backdrop {
  z-index: 1055 !important;
}

.nav-link-active {
  background-color: var(--bs-nav-active-bg) !important;
  color: var(--bs-dark) !important;
}

.bg-overridden {
  background-color: rgb(255 242 176);
  border-color: rgb(239 221 135);
}

.h-10 {
  height: 10% !important;
}

/* button styles */
.btn-light {
  background-color: #dee2e6;
  min-height: 32px;
}

.btn-green-light {
  background-color: #477F1F1A;
  color: var(--green-600);
  border-color: #477F1F1A;
}

.btn-red-light, .btn-red-light:hover {
  background-color: #F2250A1A;
  color: var(--red-600);
  font-weight: 600;
}

.icon-button-small {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.text-yellow-900 {
  color: var(--yellow-900);
}

.text-neutral-600 {
  color: var(--neutral-600 );
}

.text-neutral-800 {
  color: var(--neutral-800);
}

.text-sm-danger {
  font-size: 14px;
  color: var(--red-600);
}

.text-sm-hint {
  font-size: 14px;
  color: var(--neutral-600);
}

/* Card Styles */
.list-card {
  background-color: var(--neutral-50);
  border: 1px solid var(--neutral-200);
  border-radius: 8px;
  padding: 16px 8px 8px;
  width: 720px;
}

.list-card-title {
  font-size: 12px;
  font-weight: 500;
  color: var(--neutral-600);
  line-height: 1.2;
  padding-bottom: 8px;
}

/* The card insets its title by 8px. Scoped to the card so the title style can still be
   borrowed for section headings outside one (the assign-procedure modals) without shifting them. */
.list-card > .list-card-title {
  padding-left: 8px;
  padding-right: 8px;
}

.list-card-block-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--neutral-950);
  letter-spacing: -0.36px;
  line-height: 1.2;
  margin: 0;
}

.list-card-meta {
  font-size: 12px;
  font-weight: 500;
  color: var(--neutral-600);
  line-height: 1.2;
  margin: 0;
}

.list-card-help-text {
  font-size: 12px;
  color: var(--neutral-500);
  margin-top: 12px;
  letter-spacing: -0.24px;
  text-align: center;
}

.list-card-block {
  background-color: #fff;
  border: 1px solid var(--neutral-200);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

.list-card-item {
  background-color: #fff;
  border: 1px solid var(--neutral-200);
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 11px;
  gap: 12px;
  justify-content: space-between;
}

.list-card-item-name {
  font-size: 14px;
  color: var(--neutral-900);
  letter-spacing: -0.28px;
  line-height: 1.2;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.list-card-item-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  flex: 1;
  min-width: 0;
  line-height: 1.2;
}

.list-card-item-detail {
  font-size: 10px;
  font-weight: 500;
  color: var(--neutral-600);
  text-align: left;
}

.empty-list-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
}

/* Empty state for a list card: the card's white content block with a centered message. */
.list-card-empty {
  background-color: #fff;
  border: 1px solid var(--neutral-200);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  margin-top: 8px;
}

/* Matches the bottom spacing of a populated .attachment-items-container so the card keeps the
   same spacing whether or not the block is followed by an action button. */
.list-card-empty-with-action {
  margin-bottom: 12px;
}

.list-card-empty-text {
  font-size: 14px;
  color: var(--neutral-500);
  line-height: 1.2;
  letter-spacing: -0.28px;
  text-align: center;
  margin: 0;
}

.attachment-items-container {
  background-color: white;
  border: 1px solid var(--neutral-200);
  border-radius: 4px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
  margin-bottom: 12px;
}

/* Custom styled form input matching Figma neutral palette */
.form-label-neutral {
  font-size: 12px;
  font-weight: 500;
  color: var(--neutral-700);
  margin-bottom: 4px;
}

.form-control-neutral {
  background-color: var(--neutral-50);
  border: 1px solid var(--neutral-100);
  border-radius: 4px;
  height: 48px;
  font-size: 16px;
  color: #333;
  padding: 14.5px 16px;
}

.form-description-neutral {
  font-size: 12px;
  font-weight: 400;
  color: var(--neutral-600);
  margin-bottom: 4px;
}

.form-textarea-neutral {
  background-color: var(--neutral-50);
  border: 1px solid var(--neutral-100);
  border-radius: 4px;
  font-size: 16px;
  color: #333;
  padding: 16px;
}

.form-control-neutral::placeholder,
.form-textarea-neutral::placeholder {
  color: var(--neutral-500);
  font-weight: 400;
}

.form-control-neutral:focus
.form-textarea-neutral:focus {
  background-color: var(--neutral-50);
  border-color: #c4c0be;
  box-shadow: none;
}

.form-control-neutral.form-control-pill {
  border-radius: 99px;
}

.form-control-white {
  border: 1px solid var(--neutral-100);
  border-radius: 4px;
  font-size: 16px;
  color: var(--neutral-950);
  background-color: white;
  width: 100%;
  padding: 14.5px 16px;
  height: 48px;

  &:focus {
    outline: none;
    border-color: var(--blue-600);
  }
}

.form-check-input {
  width: 20px;
  height: 20px;
  margin-right: 12px;
  border: 2px solid var(--neutral-400);
  background-color: transparent;

  &:checked {
    background-color: var(--blue-600);
    border-color: var(--blue-600);
  }

  &:focus {
    box-shadow: 0 0 0 0;
    border-color: var(--neutral-400);
  }

  &:checked:focus {
    border-color: var(--blue-600);
  }
}

.form-check-input[type="radio"] {
  &:checked {
    background-color: #fff;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  }
}

.form-check-label {
  font-size: 16px;
  color: var(--neutral-900);
}


/* File upload drop zone */
.file-drop-zone {
  background-color: var(--neutral-50);
  border: 1px dashed var(--neutral-400);
  border-radius: 4px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 137px;
  cursor: pointer;
  transition: border-color 0.2s;
}

.file-drop-zone:hover {
  border-color: var(--neutral-500);
}

.file-drop-zone-text {
  font-size: 14px;
  color: var(--neutral-500);
  text-align: center;
  margin-bottom: 12px;
}

.file-drop-zone-selected {
  font-size: 14px;
  color: #333;
  text-align: center;
  margin-bottom: 12px;
}

/* File attachment card (shown after file is selected) */
.previewable-file-button {
  display: flex;
  align-items: center;
  gap: 12px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 0;
}
  

.previewable-file:hover {
  background-color: var(--blue-50);
  border-color: var(--blue-100);
  cursor: pointer;
}

.previewable-file:hover .list-card-item-name {
  text-decoration: underline;
}

/* Evidence submission row card */
.evidence-submission-row-muted .file-info,
.evidence-submission-row-muted > svg {
  opacity: 0.5;
}

/* Evidence category block */
.category-block {
  background-color: #fff;
  border: 1px solid var(--neutral-200);
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 12px;
}

.category-block-description {
  font-size: 14px;
  font-weight: 400;
  color: var(--neutral-700);
  letter-spacing: -0.28px;
  line-height: 1.2;
  margin: 4px 0 0;
}

/* Evidence submission card (two-part: header + body) */
.evidence-card {
  width: 308px;
}

.evidence-card-body {
  background-color: var(--neutral-50);
  border: 1px solid var(--neutral-200);
  border-top: none;
  border-radius: 0 0 4px 4px;
  padding: 12px 11px;
}

.evidence-card-review-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.24px;
  line-height: 1.5;
}

.evidence-card-review-date {
  font-size: 10px;
  font-weight: 500;
  color: var(--neutral-500);
  letter-spacing: -0.2px;
  line-height: 1.5;
  margin: 0;
}

.fusa-badge {
  text-align: center;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%; /* 10px */
  letter-spacing: 0.2px;
  text-transform: uppercase;
  border-radius: 100px;
  color: white;
  display: inline-flex;
  align-self: flex-start;
  padding: 4.2px 7.8px;
  justify-content: center;
  align-items: center;
}

/* Menu button (neutral dropdown trigger) */
.btn-menu {
  border: 1px solid var(--neutral-300);
  border-radius: 4px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.24px;
  white-space: nowrap;
  cursor: pointer;
}

.btn-menu.dropdown-toggle::after {
  display: none;
}

/* Custom outcome dropdown menu */
.outcome-dropdown-menu {
  background-color: #fff;
  border: 1px solid var(--neutral-300);
  border-radius: 8px;
  box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.17);
  padding: 12px 8px;
  min-width: 140px;
}

.outcome-dropdown-menu .dropdown-item {
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.3px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  border-radius: 4px;
}

.outcome-dropdown-menu .dropdown-item-passing:hover {
  background-color: var(--green-100);
}

.outcome-dropdown-menu .dropdown-item-failing:hover {
  background-color: var(--red-100);
}

.outcome-dropdown-menu .dropdown-item-deviated:hover {
  background-color: var(--yellow-100);
}

/* Lock status dropdown toggle button variants */
.lock-status-btn-active {
  background-color: var(--neutral-50);
  border-color: var(--neutral-300);
  color: var(--neutral-800);
}

.lock-status-btn-warning {
  background-color: var(--yellow-400);
  border-color: var(--yellow-500);
  color: var(--yellow-900);
}

.lock-status-btn-locked {
  background-color: var(--red-100);
  border-color: var(--red-600);
  color: var(--red-800);
}

/* Lock status trigger button (icon pill + label) */
.lock-status-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px 4px 4px;
  border-radius: 4px;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: var(--neutral-950);
  white-space: nowrap;
  line-height: 1.2;
}

.lock-status-trigger:hover {
  background-color: var(--neutral-100);
}

.lock-status-trigger-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  flex-shrink: 0;
}

.form-control-neutral:disabled {
  background-color: var(--neutral-300);
  border-color: var(--neutral-400);
  color: var(--neutral-600);
  opacity: 1;
}

.fusa-table {
  background-color: #fff;
  border: 1px solid var(--neutral-200);
  border-radius: 4px;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.fusa-table th,
.fusa-table td {
  padding: 8px 12px;
  border-bottom: 1px solid var(--neutral-200);
  vertical-align: middle;
}

.fusa-table-header th {
  padding-top: 12px;
  font-size: 12px;
  font-weight: 600;
  color: var(--neutral-600);
}

.fusa-table tbody tr:last-child td {
  border-bottom: none;
}

.fusa-table-cell-text {
  font-size: 14px;
  font-weight: 500;
  color: var(--neutral-950);
  line-height: 1.2;
}

.verification-criteria-table-description {
  max-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.verification-criteria-panel-subtitle {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: var(--neutral-700);
}

.verification-criteria-task-row {
  align-items: flex-start;
}

.verification-criteria-task-description {
  flex: 1 1 auto;
  border: none;
  background-color: white;
  font-size: 14px;
  line-height: 1.4;
  padding: 3px 6px;
  resize: none;
  overflow: hidden;
  field-sizing: content;
}

.verification-criteria-task-description:focus {
  box-shadow: none;
  outline: none;
}

.verification-criteria-task-description::placeholder {
  color: var(--neutral-500);
}

.verification-criteria-task-status-accepted,
.verification-criteria-task-status-accepted:hover,
.verification-criteria-task-status-accepted:focus,
.verification-criteria-task-status-accepted:active {
  background-color: var(--green-600);
  border-color: var(--green-800);
  color: white;
}

.verification-criteria-task-status-rejected,
.verification-criteria-task-status-rejected:hover,
.verification-criteria-task-status-rejected:focus,
.verification-criteria-task-status-rejected:active {
  background-color: #b02a37;
  border-color: #58151c;
  color: white;
}

.dut-project-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--neutral-950);
  line-height: 1.2;
}

.dut-project-description {
  font-size: 12px;
  font-weight: 500;
  color: var(--neutral-600);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Figma-styled tab bar */
.veriform-tab-bar {
  display: flex;
  border-bottom: 3px solid var(--neutral-200);
}

.veriform-tab {
  padding: 8px 16px 12px;
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.26px;
  line-height: 1.2;
  white-space: nowrap;
  color: var(--neutral-500);
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -3px;
  background: transparent;
}

.veriform-tab.active {
  color: var(--neutral-900);
  border-bottom-color: var(--blue-600);
}

/* File preview modal */
.file-preview-dialog {
  max-width: 900px;
}

.file-preview-modal {
  background-color: var(--neutral-950);
  border: 1px solid #000;
  border-radius: 8px;
  box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.17);
  overflow: hidden;
}

.file-preview-close-btn {
  background-color: rgba(255, 255, 255, 0.1);
  color: var(--neutral-200);
}

.file-preview-close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.file-preview-content {
  background-color: var(--neutral-800);
  border: 1px solid var(--neutral-950);
  border-radius: 4px;
  margin: 0 7px 7px 0;
  overflow: auto;
  padding: 16px 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
}

.file-preview-content--pdf {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
  padding: 16px;
}

.file-preview-content--pdf canvas {
  max-width: 100%;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}

.file-preview-content img,
.file-preview-content video {
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
}

.file-preview-content img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}

.file-preview-content video {
  max-width: 100%;
  max-height: 80vh;
}

/* File preview modal — sidebar layout (submission context) */
.file-preview-with-sidebar {
  display: flex;
  height: 95vh;
}

.file-preview-sidebar {
  flex-shrink: 0;
  width: 280px;
  display: flex;
  flex-direction: column;
}

.file-preview-sidebar-title {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.4px;
  color: white;
}

.file-preview-sidebar-filename {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: -0.24px;
  color: var(--neutral-200);
  margin: 8px 0 0;
}


.file-preview-sidebar-actions {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 19px;
}

.file-preview-accept-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background-color: rgba(255, 255, 255, 0.3);
  color: var(--blue-500);
}

.vc-sidebar-section {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.15) transparent;
  border-top: 1px solid var(--neutral-900);
  padding-top: 8px;
  padding-left: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vc-sidebar-section::-webkit-scrollbar {
  width: 4px;
}

.vc-sidebar-section::-webkit-scrollbar-track {
  background: transparent;
}

.vc-sidebar-section::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 4px;
}

.vc-sidebar-section::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25);
}

.vc-card {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  padding: 10px 12px;
  position: relative;
}

.vc-card-title {
  font-size: 13px;
  font-weight: 400;
  color: white;
  line-height: 1.2;
  flex: 1;
  min-width: 0;
  margin: 0;
}

.vc-card-description {
  font-size: 11px;
  line-height: 1.3;
  color: var(--neutral-300);
  margin-top: 6px;
  white-space: pre-wrap;
}

.vc-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 10px;
  padding: 1px 6px 1px 1px;
  margin-top: 6px;
}

.vc-badge-label {
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.18px;
  line-height: 12px;
  color: var(--neutral-950);
}

.vc-badge-accepted {
  background-color: var(--green-400);
}

.vc-badge-rejected {
  background-color: var(--red-400);
}

.vc-badge-missing {
  background-color: var(--neutral-400);
}

.vc-edit-toggle {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.vc-edit-toggle::after {
  display: none;
}

.vc-status-menu {
  background: var(--neutral-900);
  border: 1px solid var(--neutral-800);
  border-radius: 8px;
  padding: 12px 8px;
  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.17);
  min-width: 200px;
}

.vc-status-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border-radius: 4px;
  background: none;
  border: none;
  width: 100%;
  cursor: pointer;
  font-size: 13px;
  color: var(--neutral-50);
}

.vc-status-menu-item:hover,
.vc-status-menu-item:focus {
  background: rgba(255, 255, 255, 0.08);
  color: var(--neutral-50);
}

.assign-template-search {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  width: 324px;
}

.assign-template-search input {
  border: none;
  outline: none;
}

.template-list-container {
  background-color: white;
  border: 1px solid var(--neutral-200);
  border-radius: 4px;
  max-height: 500px;
  overflow-y: auto;
  padding-top: 12px;
}

.template-list-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  cursor: pointer;
  padding: 16px 24px;
}

.template-list-item.selected {
  background-color: var(--blue-50);
}

.template-list-item-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--neutral-900);
  margin: 0;
}

.template-list-item-description {
  font-size: 13px;
  color: var(--neutral-600);
  margin: 4px 0 0;
}

.generated-procedure-card-item {
  background-color: #fff;
  border: 1px solid var(--neutral-200);
  border-radius: 4px;
}

.generated-procedure-card-item-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px;
  justify-content: space-between;
}

/* Configuration Details table */
.config-details {
  display: grid;
  grid-template-columns: 128px 1fr;
  font-family: 'Roboto Mono', monospace;
  font-size: 12px;
  line-height: normal;
  max-width: 688px;
}

.config-details-property {
  background-color: var(--blue-100);
  border-top: 1px solid var(--blue-200);
  border-right: 1px solid var(--blue-200);
  padding: 12px;
  color: var(--neutral-700);
  text-align: right;
  font-weight: 400;
}

.config-details-value {
  background-color: var(--blue-50);
  padding: 12px;
  color: var(--neutral-950);
  font-weight: 400;
  border-top: 1px solid var(--blue-200);
  white-space: pre-line;
}

.config-details-separator {
  color: var(--neutral-400);
}

.config-toggle-link {
  background: none;
  border: none;
  padding: 0;
  font-size: 10px;
  font-weight: 500;
  color: var(--blue-600);
  cursor: pointer;
  line-height: 1.2;
}

.config-toggle-link:hover {
  text-decoration: underline;
}

.procedure-details {
  color: var(--neutral-600);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: 0.28px;
  text-transform: uppercase;
}

.side-panel {
  width: 694px !important;
}

.side-panel-container {
  padding: 24px 47px 16px;
}

.side-panel-footer {
  flex-shrink: 0;
  margin: 0 -47px -16px;
  padding: 19px 47px;
  background-color: var(--neutral-50);
  border-top: 1px solid var(--neutral-400);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);
}

.panel-heading {
  font-size: 24px;
  color: var(--neutral-950);
  letter-spacing: -0.48px;
}

.light-card {
  background-color: var(--neutral-50);
  border: 1px solid var(--neutral-200);
  border-radius: 8px;
}

.light-card-header {
  font-size: 12px;
  font-weight: 500;
  color: var(--neutral-600);
  padding: 12px 15px;
  border-bottom: 1px solid var(--neutral-200);
}

.light-card-body {
  padding: 12px 15px;
}

.product-page-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 7px 7px 15px;
}

.product-page-section-label {
  font-weight: 500;
  font-size: 12px;
  color: var(--neutral-600);
  padding-left: 7px;
}

.product-page-section-body {
  padding: 0 7px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-page-section-footer {
  padding: 7px;
}

.product-page-content-card {
  background-color: #fff;
  border: 1px solid var(--neutral-200);
  border-radius: 4px;
  overflow: hidden;
  padding: 11px;
}

.product-page-content-type-label {
  font-weight: 500;
  font-size: 14px;
  color: var(--neutral-950);
}

.product-page-textarea {
  background-color: var(--neutral-50);
  border: 1px solid var(--neutral-100);
  border-radius: 4px;
  font-size: 16px;
  color: var(--neutral-950);
  min-height: 80px;

  &::placeholder {
    color: var(--neutral-500);
  }

  &:focus {
    background-color: var(--neutral-50);
    border-color: var(--blue-600);
    box-shadow: 0 0 0 0.15rem rgba(46, 107, 155, 0.25);
  }
}

.product-page-section-title {
  color: var(--neutral-800);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 21.6px */
  padding-bottom: 12px;
}

.product-page-section-description {
  color: var(--neutral-800);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  white-space: pre-wrap;
}

.product-page-content-title {
  color: var(--neutral-800);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 21px */
}

.fusa-btn-small,
.fusa-btn-small:hover {
  display: inline-flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 18px */
  letter-spacing: -0.24px;
  border-radius: 4px;
  border-color: transparent;
}

.fusa-btn-small-with-icon {
  display: inline-flex;
  padding: 4px 8px 4px 6px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: var(--white, #FFF);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 18px */
  letter-spacing: -0.24px;
  border-radius: 4px;
  border-color: transparent;
}

.fusa-btn-medium {
  display: inline-flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  color: var(--white, #FFF);
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 27px */
  letter-spacing: -0.3px;
  border-color: transparent;
}

.fusa-btn-medium-with-icon {
  display: inline-flex;
  padding: 8px 16px 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  color: var(--white, #FFF);
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 27px */
  letter-spacing: -0.3px;
  border-color: transparent;
}

.fusa-btn-medium-icon {
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border-color: transparent;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 27px */
  letter-spacing: -0.3px;
}

.fusa-btn-large {
  display: inline-flex;
  padding: 12px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  color: var(--white, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 27px */
  letter-spacing: -0.36px;
  border-color: transparent;
}

.fusa-btn-large-with-icon {
  display: inline-flex;
  padding: 12px 24px 12px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  color: var(--white, #FFF);
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 27px */
  letter-spacing: -0.36px;
  border-color: transparent;
}

.fusa-btn-icon {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.fusa-menu-btn {
  display: inline-flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  color: white;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 18px */
  letter-spacing: -0.24px;
  border-color: transparent;

  &::after {
    display: none;
  }
}

.fusa-menu-btn-neutral {
  display: inline-flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  color: white;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 18px */
  letter-spacing: -0.24px;
  border: 1px solid var(--neutral-300);

  &::after {
    display: none;
  }

  color: var(--neutral-800);
  background-color: var(--neutral-50);
}

.fusa-menu-item {
  color: var(--neutral-950);
  font-size: 16px;
}

.fusa-btn-primary,
.fusa-btn-primary:hover {
  background-color: var(--blue-600);
  color: white;
}

.fusa-btn-white,
.fusa-btn-white:hover {
  background-color: white;
  color: var(--blue-600);

  &:disabled {
    opacity: 0.3;
  }
}

.fusa-btn-danger,
.fusa-btn-danger:hover {
  background-color: var(--red-600);
  color: white;
}

.fusa-btn-primary:disabled {
  opacity: 0.3;
}

.btn-blue-light,
.btn-blue-light:hover {
  background-color: #2E6B9B1A;
  color: var(--blue-600);
  border-color: transparent;
}

.btn-neutral-light,
.btn-neutral-light:hover {
  background: transparent;
  color: var(--neutral-600);
}

.btn-neutral-dark,
.btn-neutral-dark:hover {
  background: var(--neutral-900);
  color: white;
}

.btn-neutral-middle,
.btn-neutral-middle:hover
{
  background: color-mix(in srgb, var(--neutral-900) 10%, transparent);
  color: var(--neutral-900);
}

.btn-neutral-light:disabled {
  opacity: 0.3;
}

.fusa-modal-title {
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-bottom: 16px;
}

.object-list-card {
  display: flex;
  align-items: flex-start;
  background-color: white;
  border: 1px solid var(--neutral-200);
  border-radius: 4px;
  padding: 11px 15px 11px 11px;
  overflow: hidden;
  gap: 12px;
  width: 560px;
}

.object-list-card-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  flex: 1;
}

.object-list-card-title {
  font-size: 14px;
  font-weight: 500;
  color: var(--neutral-900);
  letter-spacing: -0.28px;
  line-height: 1.2;
}

.data-type-badge {
  display: inline-flex;
  align-items: center;
}

.data-type-badge-label,
.data-type-badge-value {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

.data-type-badge-label {
  padding: 2px 4px 3px 8px;
  border-radius: 99px 0 0 99px;
  color: white;
}

.data-type-badge-value {
  padding: 2px 8px 3px 4px;
  border-radius: 0 99px 99px 0;
}

.data-type-badge-label-boolean { background-color: var(--green-600); }
.data-type-badge-value-boolean { background-color: var(--green-300); color: var(--green-800); }

.data-type-badge-label-integer { background-color: var(--blue-600); }
.data-type-badge-value-integer { background-color: var(--blue-300); color: var(--blue-800); }

.data-type-badge-label-float { background-color: var(--orange-600); }
.data-type-badge-value-float { background-color: var(--orange-300); color: var(--orange-800); }

.data-type-badge-label-text { background-color: var(--pink-600); }
.data-type-badge-value-text { background-color: var(--pink-300); color: var(--pink-900); }

.requirement-item {
  border-bottom: 1px solid var(--Neutral-neutral-200, #E6E4E2);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 12px 12px;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

.requirement-item:hover {
  background-color: var(--neutral-100);
  color: inherit;
  text-decoration: none;
}

.validation-items {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 8px;
  font-size: 16px;
}

.validation-item {
  display: flex;
  align-items: start;
  gap: 4px;
}

.validation-item-title-failed {
  font-weight: 600;
  color: var(--red-800);
  padding-right: 4px;
}

.validation-item-title-passed {
  font-weight: 600;
  color: var(--green-800);
  padding-right: 4px;
}

.validation-item-message {
  font-weight: 400;
  color: var(--neutral-600);
  white-space: pre-wrap;
}

.fusa-progress {
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 2px;
  flex: 0 1 auto;
  overflow: hidden;
}

.fusa-progress-segment {
  width: 8px;
  height: 16px;
  border-radius: 2px;
  flex-shrink: 0;
}

.fusa-progress-segment--filled {
  background-color: var(--blue-400);
}

.fusa-progress-segment--empty {
  background-color: var(--blue-200);
}

/* --- Condensed template view (FUS-153) ------------------------------------ */

/* The "Advanced View" disclosure bar sits above every templated item; collapsed
   it should read as a thin strip rather than a full-height panel. */
.advanced-view-bar {
  min-height: 1.75rem;
}

/* Marks an Advanced View that holds configured values while collapsed. */
.advanced-view-marker {
  display: inline-block;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 50%;
  background-color: var(--blue-600);
  vertical-align: middle;
}

/* Slim insertion strip standing in for a row of "add" buttons. Collapsed it is
   a thin band with a faint centred "+"; the hairline and a brighter glyph only
   appear on hover or keyboard focus, so at rest it reads as breathing room. */
.add-row-trigger {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 0.875rem;
  padding: 0;
  border: 0;
  background: none;
  line-height: 1;
  cursor: pointer;
}

.add-row-trigger::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  height: 1px;
  background-color: transparent;
  transition: background-color 0.12s ease-in-out;
}

.add-row-plus {
  position: relative;
  z-index: 1;
  padding: 0 0.3rem;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1;
  color: var(--bs-secondary-color, #6c757d);
  opacity: 0.35;
  background-color: transparent;
  transition: opacity 0.12s ease-in-out, color 0.12s ease-in-out;
}

.add-row-trigger:hover .add-row-plus,
.add-row-trigger:focus-visible .add-row-plus {
  opacity: 1;
  color: var(--blue-600);
}

.add-row-trigger:hover::before,
.add-row-trigger:focus-visible::before {
  background-color: var(--blue-300);
}

.add-row-trigger:focus-visible {
  outline: 2px solid var(--blue-400);
  outline-offset: 1px;
}

.add-row-open {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.add-row-close {
  border: 0;
  font-size: 1.1rem;
  line-height: 1;
}

/* Parameter edit row. The title/identifier inputs fill the available space
   but never shrink below a usable width; when a long selected title in the
   "Assign value from/to" select would squeeze them, the select wraps onto its
   own line and truncates instead of pushing the row off the page. */
.parameter-row-fields {
  display: flex;
  flex: 1 1 0;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 0.5rem;
  min-width: 0;
}

.parameter-row-title {
  flex: 5 1 0;
  min-width: 180px;
}

.parameter-row-identifier {
  flex: 4 1 0;
  min-width: 180px;
}

.parameter-row-link {
  min-width: 0;
  max-width: 100%;
}

.parameter-row-link > div {
  min-width: 0;
}

}

/*
 * Instrument state badges and the start/stop button, copied from
 * veriform-desktop (custom-bootstrap.scss:1525-1560) so an instrument looks
 * the same in both apps.
 *
 * Desktop composes these with \`@extend .fusa-badge\`. That name is already
 * taken here by an unrelated rule -- uppercase, white, smaller -- so the
 * shared properties live on .instrument-badge instead. The values are
 * desktop's.
 */
:root {
  --blue-900: #223f58;
}

.instrument-badge,
.running-badge,
.stopped-badge,
.error-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

.running-badge {
  background-color: var(--green-100);
  color: var(--green-700);
}

.stopped-badge {
  background-color: var(--neutral-100);
  color: var(--neutral-600);
}

.error-badge {
  background-color: var(--red-100);
  color: var(--red-700);
  text-decoration: underline;
}

.btn-blue-dark,
.btn-blue-dark:hover {
  background-color: var(--blue-900);
  color: white;
}

/*
 * Horizontal gutter between the sidebar and the page (FUS-233). Pages that
 * open with a breadcrumb bar (project pages, for one) are full bleed: the bar
 * and the project nav sit flush against the sidebar, so they drop it.
 */
.page-gutter {
  padding-inline: 1rem;
}

.page-gutter:has(.breadcrumb-bar) {
  padding-inline: 0;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/styles/global.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;AACF;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB;AACF;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;2FAC2F;AAC3F;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,mFAAmF;AACnF;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oDAAoD;EACpD,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;mGACmG;AACnG;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,yFAAyF;AACzF;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;2EAC2E;AAC3E;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,mCAAmC;EACnC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;EACX,oBAAoB;EACpB,YAAY;;EAEZ;IACE,aAAa;IACb,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,6BAA6B;;EAE7B;IACE,iCAAiC;IACjC,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,yDAA4J;EAC9J;AACF;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;;AAGA,0BAA0B;AAC1B;EACE,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;;AAGA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iCAAiC;AACjC;;EAEE,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,iDAAiD;EACjD,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,gDAAgD;AAChD;EACE,mCAAmC;EACnC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;;;EAIE,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,iDAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;;EAEE,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sDAAsD;EACtD,wCAAwC;EACxC,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,8BAA8B;AAChC;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,gCAAgC;EAChC,qCAAqC;EACrC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,uCAAuC;EACvC,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,mCAAmC;EACnC,wCAAwC;EACxC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;;EAEhB;IACE,yBAAyB;EAC3B;;EAEA;IACE,mCAAmC;IACnC,6BAA6B;IAC7B,kDAAkD;EACpD;AACF;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;;EAEE,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,uBAAuB;EACvB,yBAAyB;;EAEzB;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,uBAAuB;EACvB,oCAAoC;;EAEpC;IACE,aAAa;EACf;;EAEA,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,YAAY;AACd;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;;EAEtB;IACE,YAAY;EACd;AACF;;AAEA;;EAEE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,2BAA2B;EAC3B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;;EAGE,mEAAmE;EACnE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,oCAAoC;EACpC,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA,iCAAiC,kCAAkC,EAAE;AACrE,iCAAiC,kCAAkC,EAAE,uBAAuB,EAAE;;AAE9F,iCAAiC,iCAAiC,EAAE;AACpE,iCAAiC,iCAAiC,EAAE,sBAAsB,EAAE;;AAE5F,+BAA+B,mCAAmC,EAAE;AACpE,+BAA+B,mCAAmC,EAAE,wBAAwB,EAAE;;AAE9F,8BAA8B,iCAAiC,EAAE;AACjE,8BAA8B,iCAAiC,EAAE,sBAAsB,EAAE;;AAEzF;EACE,4DAA4D;EAC5D,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,+EAA+E;;AAE/E;oEACoE;AACpE;EACE,mBAAmB;AACrB;;AAEA,yEAAyE;AACzE;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;;8EAE8E;AAC9E;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,aAAa;EACb,6BAA6B;EAC7B,8DAA8D;AAChE;;AAEA;;EAEE,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;oEAGoE;AACpE;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;AAEA;;;;;;;;;EASE;AACF;EACE,mBAAmB;AACrB;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;EAEE,iCAAiC;EACjC,YAAY;AACd;;AAEA;;;;EAIE;AACF;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["/*\r\n * The app's own stylesheet, in the same `app` cascade layer as Bootstrap.\r\n *\r\n * Wrapped as a whole rather than reindented, so the diff stays readable. Being\r\n * in Bootstrap's layer -- rather than unlayered -- keeps the two in exactly the\r\n * relationship they have always had (same layer: source order and specificity\r\n * decide), while letting Tailwind's layers, which come after, reach the\r\n * shadcn/ui components. See docs/STYLING.md.\r\n */\r\n@layer app {\r\n\r\n:root {\r\n  --bs-nav-active-bg: rgba(0, 0, 0, 0.1);\r\n  --green-800: #34571D;\r\n  --green-700: #3E6C1F;\r\n  --green-600: #477F1F;\r\n  --green-400: #87cd4e;\r\n  --green-300: #a8de78;\r\n  --green-200: #CAECAA;\r\n  --green-100: #E4F5D2;\r\n  --blue-800: #254e6f;\r\n  --blue-700: #26567E;\r\n  --blue-600: #2E6B9B;\r\n  --blue-400: #63A3CD;\r\n  --blue-300: #99c2e0;\r\n  --blue-200: #C9DDEE;\r\n  --blue-100: #D6E6F2;\r\n  --blue-50: #F3F7FC;\r\n  --red-800: #9B1E09;\r\n  --red-700: #B71b06;\r\n  --red-600: #F2250A;\r\n  --red-500: #FF4320;\r\n  --red-400: #FF7755;\r\n  --red-200: #FFD0BE;\r\n  --red-100: #FFE6DB;\r\n  --pink-900: #811a3f;\r\n  --pink-600: #d82a71;\r\n  --pink-300: #f8a9d1;\r\n  --orange-800: #9c3910;\r\n  --orange-600: #ee6108;\r\n  --orange-300: #ffc072;\r\n  --yellow-900: #722F15;\r\n  --yellow-700: #A25711;\r\n  --yellow-600: #C08F0E;\r\n  --yellow-500: #E0B114;\r\n  --yellow-400: #F0D333;\r\n  --yellow-200: #F8F190;\r\n  --yellow-100: #FBFAC6;\r\n  --neutral-50: #F8F8F8;\r\n  --neutral-100: #F1F0EF;\r\n  --neutral-200: #E6E4E2;\r\n  --neutral-300: #D9D6D4;\r\n  --neutral-400: #B9B4B0;\r\n  --neutral-500: #9f9894;\r\n  --neutral-600: #87807B;\r\n  --neutral-800: #5E5956;\r\n  --neutral-700: #706965;\r\n  --neutral-600: #87807B;\r\n  --neutral-950: #292726;\r\n  --neutral-900: #514D4B;\r\n  --gray-600: #6C757D\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n/* Page-level heading. Continues the -0.02em tracking scale the card titles use\r\n   (18px/-0.36px, 12px/-0.24px). Margin is zeroed so the page container owns the spacing. */\r\n.page-title {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: var(--neutral-950);\r\n  letter-spacing: -0.48px;\r\n  line-height: 1.2;\r\n  margin: 0;\r\n}\r\n\r\n.w-95 {\r\n  width: 95% !important;\r\n}\r\n\r\n.max-w-75 {\r\n  max-width: 75% !important;\r\n}\r\n\r\n/* Lets a flex item shrink below its content width (e.g. so text-truncate works). */\r\n.min-w-0 {\r\n  min-width: 0 !important;\r\n}\r\n\r\n.hide-scrollbar {\r\n  -ms-overflow-style: none;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.hide-scrollbar::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.nav-tabs .nav-item .nav-link {\r\n  background-color: rgba(33, 37, 41, 0.03);\r\n  color: black;\r\n}\r\n\r\n.nav-tabs .nav-item .nav-link.active {\r\n  background-color: white;\r\n}\r\n\r\n.modal-fixed-width {\r\n  width: 80vw;\r\n  max-width: 80vw;\r\n}\r\n\r\n.modal-body-fixed {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 80vh;\r\n  overflow: scroll;\r\n}\r\n\r\n.nested-modal-backdrop {\r\n  z-index: 1055 !important;\r\n}\r\n\r\n.nav-link-active {\r\n  background-color: var(--bs-nav-active-bg) !important;\r\n  color: var(--bs-dark) !important;\r\n}\r\n\r\n.bg-overridden {\r\n  background-color: rgb(255 242 176);\r\n  border-color: rgb(239 221 135);\r\n}\r\n\r\n.h-10 {\r\n  height: 10% !important;\r\n}\r\n\r\n/* button styles */\r\n.btn-light {\r\n  background-color: #dee2e6;\r\n  min-height: 32px;\r\n}\r\n\r\n.btn-green-light {\r\n  background-color: #477F1F1A;\r\n  color: var(--green-600);\r\n  border-color: #477F1F1A;\r\n}\r\n\r\n.btn-red-light, .btn-red-light:hover {\r\n  background-color: #F2250A1A;\r\n  color: var(--red-600);\r\n  font-weight: 600;\r\n}\r\n\r\n.icon-button-small {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 26px;\r\n  height: 26px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.text-yellow-900 {\r\n  color: var(--yellow-900);\r\n}\r\n\r\n.text-neutral-600 {\r\n  color: var(--neutral-600 );\r\n}\r\n\r\n.text-neutral-800 {\r\n  color: var(--neutral-800);\r\n}\r\n\r\n.text-sm-danger {\r\n  font-size: 14px;\r\n  color: var(--red-600);\r\n}\r\n\r\n.text-sm-hint {\r\n  font-size: 14px;\r\n  color: var(--neutral-600);\r\n}\r\n\r\n/* Card Styles */\r\n.list-card {\r\n  background-color: var(--neutral-50);\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 8px;\r\n  padding: 16px 8px 8px;\r\n  width: 720px;\r\n}\r\n\r\n.list-card-title {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  color: var(--neutral-600);\r\n  line-height: 1.2;\r\n  padding-bottom: 8px;\r\n}\r\n\r\n/* The card insets its title by 8px. Scoped to the card so the title style can still be\r\n   borrowed for section headings outside one (the assign-procedure modals) without shifting them. */\r\n.list-card > .list-card-title {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n}\r\n\r\n.list-card-block-title {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: var(--neutral-950);\r\n  letter-spacing: -0.36px;\r\n  line-height: 1.2;\r\n  margin: 0;\r\n}\r\n\r\n.list-card-meta {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  color: var(--neutral-600);\r\n  line-height: 1.2;\r\n  margin: 0;\r\n}\r\n\r\n.list-card-help-text {\r\n  font-size: 12px;\r\n  color: var(--neutral-500);\r\n  margin-top: 12px;\r\n  letter-spacing: -0.24px;\r\n  text-align: center;\r\n}\r\n\r\n.list-card-block {\r\n  background-color: #fff;\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.list-card-item {\r\n  background-color: #fff;\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 11px;\r\n  gap: 12px;\r\n  justify-content: space-between;\r\n}\r\n\r\n.list-card-item-name {\r\n  font-size: 14px;\r\n  color: var(--neutral-900);\r\n  letter-spacing: -0.28px;\r\n  line-height: 1.2;\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.list-card-item-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  gap: 3px;\r\n  flex: 1;\r\n  min-width: 0;\r\n  line-height: 1.2;\r\n}\r\n\r\n.list-card-item-detail {\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  color: var(--neutral-600);\r\n  text-align: left;\r\n}\r\n\r\n.empty-list-card-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  padding-top: 40px;\r\n}\r\n\r\n/* Empty state for a list card: the card's white content block with a centered message. */\r\n.list-card-empty {\r\n  background-color: #fff;\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 32px 16px;\r\n  margin-top: 8px;\r\n}\r\n\r\n/* Matches the bottom spacing of a populated .attachment-items-container so the card keeps the\r\n   same spacing whether or not the block is followed by an action button. */\r\n.list-card-empty-with-action {\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.list-card-empty-text {\r\n  font-size: 14px;\r\n  color: var(--neutral-500);\r\n  line-height: 1.2;\r\n  letter-spacing: -0.28px;\r\n  text-align: center;\r\n  margin: 0;\r\n}\r\n\r\n.attachment-items-container {\r\n  background-color: white;\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 4px;\r\n  padding: 15px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-top: 8px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n/* Custom styled form input matching Figma neutral palette */\r\n.form-label-neutral {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  color: var(--neutral-700);\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.form-control-neutral {\r\n  background-color: var(--neutral-50);\r\n  border: 1px solid var(--neutral-100);\r\n  border-radius: 4px;\r\n  height: 48px;\r\n  font-size: 16px;\r\n  color: #333;\r\n  padding: 14.5px 16px;\r\n}\r\n\r\n.form-description-neutral {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  color: var(--neutral-600);\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.form-textarea-neutral {\r\n  background-color: var(--neutral-50);\r\n  border: 1px solid var(--neutral-100);\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n  color: #333;\r\n  padding: 16px;\r\n}\r\n\r\n.form-control-neutral::placeholder,\r\n.form-textarea-neutral::placeholder {\r\n  color: var(--neutral-500);\r\n  font-weight: 400;\r\n}\r\n\r\n.form-control-neutral:focus\r\n.form-textarea-neutral:focus {\r\n  background-color: var(--neutral-50);\r\n  border-color: #c4c0be;\r\n  box-shadow: none;\r\n}\r\n\r\n.form-control-neutral.form-control-pill {\r\n  border-radius: 99px;\r\n}\r\n\r\n.form-control-white {\r\n  border: 1px solid var(--neutral-100);\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n  color: var(--neutral-950);\r\n  background-color: white;\r\n  width: 100%;\r\n  padding: 14.5px 16px;\r\n  height: 48px;\r\n\r\n  &:focus {\r\n    outline: none;\r\n    border-color: var(--blue-600);\r\n  }\r\n}\r\n\r\n.form-check-input {\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-right: 12px;\r\n  border: 2px solid var(--neutral-400);\r\n  background-color: transparent;\r\n\r\n  &:checked {\r\n    background-color: var(--blue-600);\r\n    border-color: var(--blue-600);\r\n  }\r\n\r\n  &:focus {\r\n    box-shadow: 0 0 0 0;\r\n    border-color: var(--neutral-400);\r\n  }\r\n\r\n  &:checked:focus {\r\n    border-color: var(--blue-600);\r\n  }\r\n}\r\n\r\n.form-check-input[type=\"radio\"] {\r\n  &:checked {\r\n    background-color: #fff;\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2.5' fill='%232E6B9B'/%3e%3c/svg%3e\");\r\n  }\r\n}\r\n\r\n.form-check-label {\r\n  font-size: 16px;\r\n  color: var(--neutral-900);\r\n}\r\n\r\n\r\n/* File upload drop zone */\r\n.file-drop-zone {\r\n  background-color: var(--neutral-50);\r\n  border: 1px dashed var(--neutral-400);\r\n  border-radius: 4px;\r\n  padding: 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 137px;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.file-drop-zone:hover {\r\n  border-color: var(--neutral-500);\r\n}\r\n\r\n.file-drop-zone-text {\r\n  font-size: 14px;\r\n  color: var(--neutral-500);\r\n  text-align: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.file-drop-zone-selected {\r\n  font-size: 14px;\r\n  color: #333;\r\n  text-align: center;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n/* File attachment card (shown after file is selected) */\r\n.previewable-file-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  padding: 0;\r\n}\r\n  \r\n\r\n.previewable-file:hover {\r\n  background-color: var(--blue-50);\r\n  border-color: var(--blue-100);\r\n  cursor: pointer;\r\n}\r\n\r\n.previewable-file:hover .list-card-item-name {\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Evidence submission row card */\r\n.evidence-submission-row-muted .file-info,\r\n.evidence-submission-row-muted > svg {\r\n  opacity: 0.5;\r\n}\r\n\r\n/* Evidence category block */\r\n.category-block {\r\n  background-color: #fff;\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 4px;\r\n  padding: 15px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.category-block-description {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: var(--neutral-700);\r\n  letter-spacing: -0.28px;\r\n  line-height: 1.2;\r\n  margin: 4px 0 0;\r\n}\r\n\r\n/* Evidence submission card (two-part: header + body) */\r\n.evidence-card {\r\n  width: 308px;\r\n}\r\n\r\n.evidence-card-body {\r\n  background-color: var(--neutral-50);\r\n  border: 1px solid var(--neutral-200);\r\n  border-top: none;\r\n  border-radius: 0 0 4px 4px;\r\n  padding: 12px 11px;\r\n}\r\n\r\n.evidence-card-review-label {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  letter-spacing: -0.24px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.evidence-card-review-date {\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  color: var(--neutral-500);\r\n  letter-spacing: -0.2px;\r\n  line-height: 1.5;\r\n  margin: 0;\r\n}\r\n\r\n.fusa-badge {\r\n  text-align: center;\r\n  font-size: 10px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: 100%; /* 10px */\r\n  letter-spacing: 0.2px;\r\n  text-transform: uppercase;\r\n  border-radius: 100px;\r\n  color: white;\r\n  display: inline-flex;\r\n  align-self: flex-start;\r\n  padding: 4.2px 7.8px;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* Menu button (neutral dropdown trigger) */\r\n.btn-menu {\r\n  border: 1px solid var(--neutral-300);\r\n  border-radius: 4px;\r\n  padding: 4px 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  letter-spacing: -0.24px;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-menu.dropdown-toggle::after {\r\n  display: none;\r\n}\r\n\r\n/* Custom outcome dropdown menu */\r\n.outcome-dropdown-menu {\r\n  background-color: #fff;\r\n  border: 1px solid var(--neutral-300);\r\n  border-radius: 8px;\r\n  box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.17);\r\n  padding: 12px 8px;\r\n  min-width: 140px;\r\n}\r\n\r\n.outcome-dropdown-menu .dropdown-item {\r\n  font-size: 15px;\r\n  font-weight: 400;\r\n  letter-spacing: -0.3px;\r\n  height: 32px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.outcome-dropdown-menu .dropdown-item-passing:hover {\r\n  background-color: var(--green-100);\r\n}\r\n\r\n.outcome-dropdown-menu .dropdown-item-failing:hover {\r\n  background-color: var(--red-100);\r\n}\r\n\r\n.outcome-dropdown-menu .dropdown-item-deviated:hover {\r\n  background-color: var(--yellow-100);\r\n}\r\n\r\n/* Lock status dropdown toggle button variants */\r\n.lock-status-btn-active {\r\n  background-color: var(--neutral-50);\r\n  border-color: var(--neutral-300);\r\n  color: var(--neutral-800);\r\n}\r\n\r\n.lock-status-btn-warning {\r\n  background-color: var(--yellow-400);\r\n  border-color: var(--yellow-500);\r\n  color: var(--yellow-900);\r\n}\r\n\r\n.lock-status-btn-locked {\r\n  background-color: var(--red-100);\r\n  border-color: var(--red-600);\r\n  color: var(--red-800);\r\n}\r\n\r\n/* Lock status trigger button (icon pill + label) */\r\n.lock-status-trigger {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 8px 4px 4px;\r\n  border-radius: 4px;\r\n  border: none;\r\n  background: none;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: var(--neutral-950);\r\n  white-space: nowrap;\r\n  line-height: 1.2;\r\n}\r\n\r\n.lock-status-trigger:hover {\r\n  background-color: var(--neutral-100);\r\n}\r\n\r\n.lock-status-trigger-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.form-control-neutral:disabled {\r\n  background-color: var(--neutral-300);\r\n  border-color: var(--neutral-400);\r\n  color: var(--neutral-600);\r\n  opacity: 1;\r\n}\r\n\r\n.fusa-table {\r\n  background-color: #fff;\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 4px;\r\n  width: 100%;\r\n  border-collapse: separate;\r\n  border-spacing: 0;\r\n}\r\n\r\n.fusa-table th,\r\n.fusa-table td {\r\n  padding: 8px 12px;\r\n  border-bottom: 1px solid var(--neutral-200);\r\n  vertical-align: middle;\r\n}\r\n\r\n.fusa-table-header th {\r\n  padding-top: 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--neutral-600);\r\n}\r\n\r\n.fusa-table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.fusa-table-cell-text {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: var(--neutral-950);\r\n  line-height: 1.2;\r\n}\r\n\r\n.verification-criteria-table-description {\r\n  max-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  width: 100%;\r\n}\r\n\r\n.verification-criteria-panel-subtitle {\r\n  margin: 0 0 12px 0;\r\n  font-size: 14px;\r\n  color: var(--neutral-700);\r\n}\r\n\r\n.verification-criteria-task-row {\r\n  align-items: flex-start;\r\n}\r\n\r\n.verification-criteria-task-description {\r\n  flex: 1 1 auto;\r\n  border: none;\r\n  background-color: white;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  padding: 3px 6px;\r\n  resize: none;\r\n  overflow: hidden;\r\n  field-sizing: content;\r\n}\r\n\r\n.verification-criteria-task-description:focus {\r\n  box-shadow: none;\r\n  outline: none;\r\n}\r\n\r\n.verification-criteria-task-description::placeholder {\r\n  color: var(--neutral-500);\r\n}\r\n\r\n.verification-criteria-task-status-accepted,\r\n.verification-criteria-task-status-accepted:hover,\r\n.verification-criteria-task-status-accepted:focus,\r\n.verification-criteria-task-status-accepted:active {\r\n  background-color: var(--green-600);\r\n  border-color: var(--green-800);\r\n  color: white;\r\n}\r\n\r\n.verification-criteria-task-status-rejected,\r\n.verification-criteria-task-status-rejected:hover,\r\n.verification-criteria-task-status-rejected:focus,\r\n.verification-criteria-task-status-rejected:active {\r\n  background-color: #b02a37;\r\n  border-color: #58151c;\r\n  color: white;\r\n}\r\n\r\n.dut-project-title {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  color: var(--neutral-950);\r\n  line-height: 1.2;\r\n}\r\n\r\n.dut-project-description {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  color: var(--neutral-600);\r\n  line-height: 1.2;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Figma-styled tab bar */\r\n.veriform-tab-bar {\r\n  display: flex;\r\n  border-bottom: 3px solid var(--neutral-200);\r\n}\r\n\r\n.veriform-tab {\r\n  padding: 8px 16px 12px;\r\n  font-size: 13px;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.26px;\r\n  line-height: 1.2;\r\n  white-space: nowrap;\r\n  color: var(--neutral-500);\r\n  border: none;\r\n  border-bottom: 3px solid transparent;\r\n  margin-bottom: -3px;\r\n  background: transparent;\r\n}\r\n\r\n.veriform-tab.active {\r\n  color: var(--neutral-900);\r\n  border-bottom-color: var(--blue-600);\r\n}\r\n\r\n/* File preview modal */\r\n.file-preview-dialog {\r\n  max-width: 900px;\r\n}\r\n\r\n.file-preview-modal {\r\n  background-color: var(--neutral-950);\r\n  border: 1px solid #000;\r\n  border-radius: 8px;\r\n  box-shadow: 0px 16px 48px 0px rgba(0, 0, 0, 0.17);\r\n  overflow: hidden;\r\n}\r\n\r\n.file-preview-close-btn {\r\n  background-color: rgba(255, 255, 255, 0.1);\r\n  color: var(--neutral-200);\r\n}\r\n\r\n.file-preview-close-btn:hover {\r\n  background-color: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.file-preview-content {\r\n  background-color: var(--neutral-800);\r\n  border: 1px solid var(--neutral-950);\r\n  border-radius: 4px;\r\n  margin: 0 7px 7px 0;\r\n  overflow: auto;\r\n  padding: 16px 37px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 80vh;\r\n}\r\n\r\n.file-preview-content--pdf {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow-y: auto;\r\n  flex-direction: column;\r\n  justify-content: flex-start;\r\n  gap: 8px;\r\n  padding: 16px;\r\n}\r\n\r\n.file-preview-content--pdf canvas {\r\n  max-width: 100%;\r\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);\r\n  border-radius: 4px;\r\n}\r\n\r\n.file-preview-content img,\r\n.file-preview-content video {\r\n  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.15);\r\n  border-radius: 4px;\r\n}\r\n\r\n.file-preview-content img {\r\n  max-width: 100%;\r\n  max-height: 80vh;\r\n  object-fit: contain;\r\n}\r\n\r\n.file-preview-content video {\r\n  max-width: 100%;\r\n  max-height: 80vh;\r\n}\r\n\r\n/* File preview modal — sidebar layout (submission context) */\r\n.file-preview-with-sidebar {\r\n  display: flex;\r\n  height: 95vh;\r\n}\r\n\r\n.file-preview-sidebar {\r\n  flex-shrink: 0;\r\n  width: 280px;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.file-preview-sidebar-title {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  letter-spacing: -0.4px;\r\n  color: white;\r\n}\r\n\r\n.file-preview-sidebar-filename {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: 1.2;\r\n  letter-spacing: -0.24px;\r\n  color: var(--neutral-200);\r\n  margin: 8px 0 0;\r\n}\r\n\r\n\r\n.file-preview-sidebar-actions {\r\n  margin-top: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 19px;\r\n}\r\n\r\n.file-preview-accept-btn:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n  background-color: rgba(255, 255, 255, 0.3);\r\n  color: var(--blue-500);\r\n}\r\n\r\n.vc-sidebar-section {\r\n  overflow-y: auto;\r\n  scrollbar-width: thin;\r\n  scrollbar-color: rgba(255, 255, 255, 0.15) transparent;\r\n  border-top: 1px solid var(--neutral-900);\r\n  padding-top: 8px;\r\n  padding-left: 8px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.vc-sidebar-section::-webkit-scrollbar {\r\n  width: 4px;\r\n}\r\n\r\n.vc-sidebar-section::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.vc-sidebar-section::-webkit-scrollbar-thumb {\r\n  background: rgba(255, 255, 255, 0.15);\r\n  border-radius: 4px;\r\n}\r\n\r\n.vc-sidebar-section::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(255, 255, 255, 0.25);\r\n}\r\n\r\n.vc-card {\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border-radius: 4px;\r\n  padding: 10px 12px;\r\n  position: relative;\r\n}\r\n\r\n.vc-card-title {\r\n  font-size: 13px;\r\n  font-weight: 400;\r\n  color: white;\r\n  line-height: 1.2;\r\n  flex: 1;\r\n  min-width: 0;\r\n  margin: 0;\r\n}\r\n\r\n.vc-card-description {\r\n  font-size: 11px;\r\n  line-height: 1.3;\r\n  color: var(--neutral-300);\r\n  margin-top: 6px;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.vc-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  border-radius: 10px;\r\n  padding: 1px 6px 1px 1px;\r\n  margin-top: 6px;\r\n}\r\n\r\n.vc-badge-label {\r\n  font-size: 9px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.18px;\r\n  line-height: 12px;\r\n  color: var(--neutral-950);\r\n}\r\n\r\n.vc-badge-accepted {\r\n  background-color: var(--green-400);\r\n}\r\n\r\n.vc-badge-rejected {\r\n  background-color: var(--red-400);\r\n}\r\n\r\n.vc-badge-missing {\r\n  background-color: var(--neutral-400);\r\n}\r\n\r\n.vc-edit-toggle {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.vc-edit-toggle::after {\r\n  display: none;\r\n}\r\n\r\n.vc-status-menu {\r\n  background: var(--neutral-900);\r\n  border: 1px solid var(--neutral-800);\r\n  border-radius: 8px;\r\n  padding: 12px 8px;\r\n  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.17);\r\n  min-width: 200px;\r\n}\r\n\r\n.vc-status-menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  background: none;\r\n  border: none;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  color: var(--neutral-50);\r\n}\r\n\r\n.vc-status-menu-item:hover,\r\n.vc-status-menu-item:focus {\r\n  background: rgba(255, 255, 255, 0.08);\r\n  color: var(--neutral-50);\r\n}\r\n\r\n.assign-template-search {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 0 16px;\r\n  width: 324px;\r\n}\r\n\r\n.assign-template-search input {\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n.template-list-container {\r\n  background-color: white;\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 4px;\r\n  max-height: 500px;\r\n  overflow-y: auto;\r\n  padding-top: 12px;\r\n}\r\n\r\n.template-list-item {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: flex-start;\r\n  cursor: pointer;\r\n  padding: 16px 24px;\r\n}\r\n\r\n.template-list-item.selected {\r\n  background-color: var(--blue-50);\r\n}\r\n\r\n.template-list-item-title {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: var(--neutral-900);\r\n  margin: 0;\r\n}\r\n\r\n.template-list-item-description {\r\n  font-size: 13px;\r\n  color: var(--neutral-600);\r\n  margin: 4px 0 0;\r\n}\r\n\r\n.generated-procedure-card-item {\r\n  background-color: #fff;\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 4px;\r\n}\r\n\r\n.generated-procedure-card-item-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 11px;\r\n  justify-content: space-between;\r\n}\r\n\r\n/* Configuration Details table */\r\n.config-details {\r\n  display: grid;\r\n  grid-template-columns: 128px 1fr;\r\n  font-family: 'Roboto Mono', monospace;\r\n  font-size: 12px;\r\n  line-height: normal;\r\n  max-width: 688px;\r\n}\r\n\r\n.config-details-property {\r\n  background-color: var(--blue-100);\r\n  border-top: 1px solid var(--blue-200);\r\n  border-right: 1px solid var(--blue-200);\r\n  padding: 12px;\r\n  color: var(--neutral-700);\r\n  text-align: right;\r\n  font-weight: 400;\r\n}\r\n\r\n.config-details-value {\r\n  background-color: var(--blue-50);\r\n  padding: 12px;\r\n  color: var(--neutral-950);\r\n  font-weight: 400;\r\n  border-top: 1px solid var(--blue-200);\r\n  white-space: pre-line;\r\n}\r\n\r\n.config-details-separator {\r\n  color: var(--neutral-400);\r\n}\r\n\r\n.config-toggle-link {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  color: var(--blue-600);\r\n  cursor: pointer;\r\n  line-height: 1.2;\r\n}\r\n\r\n.config-toggle-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.procedure-details {\r\n  color: var(--neutral-600);\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 21px */\r\n  letter-spacing: 0.28px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.side-panel {\r\n  width: 694px !important;\r\n}\r\n\r\n.side-panel-container {\r\n  padding: 24px 47px 16px;\r\n}\r\n\r\n.side-panel-footer {\r\n  flex-shrink: 0;\r\n  margin: 0 -47px -16px;\r\n  padding: 19px 47px;\r\n  background-color: var(--neutral-50);\r\n  border-top: 1px solid var(--neutral-400);\r\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.panel-heading {\r\n  font-size: 24px;\r\n  color: var(--neutral-950);\r\n  letter-spacing: -0.48px;\r\n}\r\n\r\n.light-card {\r\n  background-color: var(--neutral-50);\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 8px;\r\n}\r\n\r\n.light-card-header {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  color: var(--neutral-600);\r\n  padding: 12px 15px;\r\n  border-bottom: 1px solid var(--neutral-200);\r\n}\r\n\r\n.light-card-body {\r\n  padding: 12px 15px;\r\n}\r\n\r\n.product-page-section-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 7px 7px 7px 15px;\r\n}\r\n\r\n.product-page-section-label {\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n  color: var(--neutral-600);\r\n  padding-left: 7px;\r\n}\r\n\r\n.product-page-section-body {\r\n  padding: 0 7px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n}\r\n\r\n.product-page-section-footer {\r\n  padding: 7px;\r\n}\r\n\r\n.product-page-content-card {\r\n  background-color: #fff;\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 4px;\r\n  overflow: hidden;\r\n  padding: 11px;\r\n}\r\n\r\n.product-page-content-type-label {\r\n  font-weight: 500;\r\n  font-size: 14px;\r\n  color: var(--neutral-950);\r\n}\r\n\r\n.product-page-textarea {\r\n  background-color: var(--neutral-50);\r\n  border: 1px solid var(--neutral-100);\r\n  border-radius: 4px;\r\n  font-size: 16px;\r\n  color: var(--neutral-950);\r\n  min-height: 80px;\r\n\r\n  &::placeholder {\r\n    color: var(--neutral-500);\r\n  }\r\n\r\n  &:focus {\r\n    background-color: var(--neutral-50);\r\n    border-color: var(--blue-600);\r\n    box-shadow: 0 0 0 0.15rem rgba(46, 107, 155, 0.25);\r\n  }\r\n}\r\n\r\n.product-page-section-title {\r\n  color: var(--neutral-800);\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 120%; /* 21.6px */\r\n  padding-bottom: 12px;\r\n}\r\n\r\n.product-page-section-description {\r\n  color: var(--neutral-800);\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 150%; /* 24px */\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.product-page-content-title {\r\n  color: var(--neutral-800);\r\n  font-size: 14px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 21px */\r\n}\r\n\r\n.fusa-btn-small,\r\n.fusa-btn-small:hover {\r\n  display: inline-flex;\r\n  padding: 4px 8px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 18px */\r\n  letter-spacing: -0.24px;\r\n  border-radius: 4px;\r\n  border-color: transparent;\r\n}\r\n\r\n.fusa-btn-small-with-icon {\r\n  display: inline-flex;\r\n  padding: 4px 8px 4px 6px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 4px;\r\n  color: var(--white, #FFF);\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 18px */\r\n  letter-spacing: -0.24px;\r\n  border-radius: 4px;\r\n  border-color: transparent;\r\n}\r\n\r\n.fusa-btn-medium {\r\n  display: inline-flex;\r\n  padding: 8px 16px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border-radius: 4px;\r\n  color: var(--white, #FFF);\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 27px */\r\n  letter-spacing: -0.3px;\r\n  border-color: transparent;\r\n}\r\n\r\n.fusa-btn-medium-with-icon {\r\n  display: inline-flex;\r\n  padding: 8px 16px 8px 12px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border-radius: 4px;\r\n  color: var(--white, #FFF);\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 27px */\r\n  letter-spacing: -0.3px;\r\n  border-color: transparent;\r\n}\r\n\r\n.fusa-btn-medium-icon {\r\n  display: flex;\r\n  width: 32px;\r\n  height: 32px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border-radius: 4px;\r\n  border-color: transparent;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 27px */\r\n  letter-spacing: -0.3px;\r\n}\r\n\r\n.fusa-btn-large {\r\n  display: inline-flex;\r\n  padding: 12px 20px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border-radius: 4px;\r\n  color: var(--white, #FFF);\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 27px */\r\n  letter-spacing: -0.36px;\r\n  border-color: transparent;\r\n}\r\n\r\n.fusa-btn-large-with-icon {\r\n  display: inline-flex;\r\n  padding: 12px 24px 12px 20px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border-radius: 4px;\r\n  color: var(--white, #FFF);\r\n  font-size: 18px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 27px */\r\n  letter-spacing: -0.36px;\r\n  border-color: transparent;\r\n}\r\n\r\n.fusa-btn-icon {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.fusa-menu-btn {\r\n  display: inline-flex;\r\n  padding: 4px 8px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border-radius: 4px;\r\n  color: white;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 18px */\r\n  letter-spacing: -0.24px;\r\n  border-color: transparent;\r\n\r\n  &::after {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.fusa-menu-btn-neutral {\r\n  display: inline-flex;\r\n  padding: 4px 8px;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 8px;\r\n  border-radius: 4px;\r\n  color: white;\r\n  font-size: 12px;\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  line-height: 150%; /* 18px */\r\n  letter-spacing: -0.24px;\r\n  border: 1px solid var(--neutral-300);\r\n\r\n  &::after {\r\n    display: none;\r\n  }\r\n\r\n  color: var(--neutral-800);\r\n  background-color: var(--neutral-50);\r\n}\r\n\r\n.fusa-menu-item {\r\n  color: var(--neutral-950);\r\n  font-size: 16px;\r\n}\r\n\r\n.fusa-btn-primary,\r\n.fusa-btn-primary:hover {\r\n  background-color: var(--blue-600);\r\n  color: white;\r\n}\r\n\r\n.fusa-btn-white,\r\n.fusa-btn-white:hover {\r\n  background-color: white;\r\n  color: var(--blue-600);\r\n\r\n  &:disabled {\r\n    opacity: 0.3;\r\n  }\r\n}\r\n\r\n.fusa-btn-danger,\r\n.fusa-btn-danger:hover {\r\n  background-color: var(--red-600);\r\n  color: white;\r\n}\r\n\r\n.fusa-btn-primary:disabled {\r\n  opacity: 0.3;\r\n}\r\n\r\n.btn-blue-light,\r\n.btn-blue-light:hover {\r\n  background-color: #2E6B9B1A;\r\n  color: var(--blue-600);\r\n  border-color: transparent;\r\n}\r\n\r\n.btn-neutral-light,\r\n.btn-neutral-light:hover {\r\n  background: transparent;\r\n  color: var(--neutral-600);\r\n}\r\n\r\n.btn-neutral-dark,\r\n.btn-neutral-dark:hover {\r\n  background: var(--neutral-900);\r\n  color: white;\r\n}\r\n\r\n.btn-neutral-middle,\r\n.btn-neutral-middle:hover\r\n{\r\n  background: color-mix(in srgb, var(--neutral-900) 10%, transparent);\r\n  color: var(--neutral-900);\r\n}\r\n\r\n.btn-neutral-light:disabled {\r\n  opacity: 0.3;\r\n}\r\n\r\n.fusa-modal-title {\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  line-height: normal;\r\n  padding-bottom: 16px;\r\n}\r\n\r\n.object-list-card {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  background-color: white;\r\n  border: 1px solid var(--neutral-200);\r\n  border-radius: 4px;\r\n  padding: 11px 15px 11px 11px;\r\n  overflow: hidden;\r\n  gap: 12px;\r\n  width: 560px;\r\n}\r\n\r\n.object-list-card-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  min-width: 0;\r\n  flex: 1;\r\n}\r\n\r\n.object-list-card-title {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: var(--neutral-900);\r\n  letter-spacing: -0.28px;\r\n  line-height: 1.2;\r\n}\r\n\r\n.data-type-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.data-type-badge-label,\r\n.data-type-badge-value {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  line-height: 1.2;\r\n  white-space: nowrap;\r\n}\r\n\r\n.data-type-badge-label {\r\n  padding: 2px 4px 3px 8px;\r\n  border-radius: 99px 0 0 99px;\r\n  color: white;\r\n}\r\n\r\n.data-type-badge-value {\r\n  padding: 2px 8px 3px 4px;\r\n  border-radius: 0 99px 99px 0;\r\n}\r\n\r\n.data-type-badge-label-boolean { background-color: var(--green-600); }\r\n.data-type-badge-value-boolean { background-color: var(--green-300); color: var(--green-800); }\r\n\r\n.data-type-badge-label-integer { background-color: var(--blue-600); }\r\n.data-type-badge-value-integer { background-color: var(--blue-300); color: var(--blue-800); }\r\n\r\n.data-type-badge-label-float { background-color: var(--orange-600); }\r\n.data-type-badge-value-float { background-color: var(--orange-300); color: var(--orange-800); }\r\n\r\n.data-type-badge-label-text { background-color: var(--pink-600); }\r\n.data-type-badge-value-text { background-color: var(--pink-300); color: var(--pink-900); }\r\n\r\n.requirement-item {\r\n  border-bottom: 1px solid var(--Neutral-neutral-200, #E6E4E2);\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 8px 12px 12px 12px;\r\n  color: inherit;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.requirement-item:hover {\r\n  background-color: var(--neutral-100);\r\n  color: inherit;\r\n  text-decoration: none;\r\n}\r\n\r\n.validation-items {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n  padding-top: 8px;\r\n  font-size: 16px;\r\n}\r\n\r\n.validation-item {\r\n  display: flex;\r\n  align-items: start;\r\n  gap: 4px;\r\n}\r\n\r\n.validation-item-title-failed {\r\n  font-weight: 600;\r\n  color: var(--red-800);\r\n  padding-right: 4px;\r\n}\r\n\r\n.validation-item-title-passed {\r\n  font-weight: 600;\r\n  color: var(--green-800);\r\n  padding-right: 4px;\r\n}\r\n\r\n.validation-item-message {\r\n  font-weight: 400;\r\n  color: var(--neutral-600);\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.fusa-progress {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: row;\r\n  gap: 2px;\r\n  flex: 0 1 auto;\r\n  overflow: hidden;\r\n}\r\n\r\n.fusa-progress-segment {\r\n  width: 8px;\r\n  height: 16px;\r\n  border-radius: 2px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.fusa-progress-segment--filled {\r\n  background-color: var(--blue-400);\r\n}\r\n\r\n.fusa-progress-segment--empty {\r\n  background-color: var(--blue-200);\r\n}\r\n\r\n/* --- Condensed template view (FUS-153) ------------------------------------ */\r\n\r\n/* The \"Advanced View\" disclosure bar sits above every templated item; collapsed\r\n   it should read as a thin strip rather than a full-height panel. */\r\n.advanced-view-bar {\r\n  min-height: 1.75rem;\r\n}\r\n\r\n/* Marks an Advanced View that holds configured values while collapsed. */\r\n.advanced-view-marker {\r\n  display: inline-block;\r\n  width: 0.4rem;\r\n  height: 0.4rem;\r\n  border-radius: 50%;\r\n  background-color: var(--blue-600);\r\n  vertical-align: middle;\r\n}\r\n\r\n/* Slim insertion strip standing in for a row of \"add\" buttons. Collapsed it is\r\n   a thin band with a faint centred \"+\"; the hairline and a brighter glyph only\r\n   appear on hover or keyboard focus, so at rest it reads as breathing room. */\r\n.add-row-trigger {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 100%;\r\n  height: 0.875rem;\r\n  padding: 0;\r\n  border: 0;\r\n  background: none;\r\n  line-height: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.add-row-trigger::before {\r\n  content: '';\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: 50%;\r\n  height: 1px;\r\n  background-color: transparent;\r\n  transition: background-color 0.12s ease-in-out;\r\n}\r\n\r\n.add-row-plus {\r\n  position: relative;\r\n  z-index: 1;\r\n  padding: 0 0.3rem;\r\n  font-size: 0.8125rem;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  color: var(--bs-secondary-color, #6c757d);\r\n  opacity: 0.35;\r\n  background-color: transparent;\r\n  transition: opacity 0.12s ease-in-out, color 0.12s ease-in-out;\r\n}\r\n\r\n.add-row-trigger:hover .add-row-plus,\r\n.add-row-trigger:focus-visible .add-row-plus {\r\n  opacity: 1;\r\n  color: var(--blue-600);\r\n}\r\n\r\n.add-row-trigger:hover::before,\r\n.add-row-trigger:focus-visible::before {\r\n  background-color: var(--blue-300);\r\n}\r\n\r\n.add-row-trigger:focus-visible {\r\n  outline: 2px solid var(--blue-400);\r\n  outline-offset: 1px;\r\n}\r\n\r\n.add-row-open {\r\n  padding-top: 0.125rem;\r\n  padding-bottom: 0.125rem;\r\n}\r\n\r\n.add-row-close {\r\n  border: 0;\r\n  font-size: 1.1rem;\r\n  line-height: 1;\r\n}\r\n\r\n/* Parameter edit row. The title/identifier inputs fill the available space\r\n   but never shrink below a usable width; when a long selected title in the\r\n   \"Assign value from/to\" select would squeeze them, the select wraps onto its\r\n   own line and truncates instead of pushing the row off the page. */\r\n.parameter-row-fields {\r\n  display: flex;\r\n  flex: 1 1 0;\r\n  flex-wrap: wrap;\r\n  align-items: flex-start;\r\n  gap: 0.5rem;\r\n  min-width: 0;\r\n}\r\n\r\n.parameter-row-title {\r\n  flex: 5 1 0;\r\n  min-width: 180px;\r\n}\r\n\r\n.parameter-row-identifier {\r\n  flex: 4 1 0;\r\n  min-width: 180px;\r\n}\r\n\r\n.parameter-row-link {\r\n  min-width: 0;\r\n  max-width: 100%;\r\n}\r\n\r\n.parameter-row-link > div {\r\n  min-width: 0;\r\n}\r\n\r\n}\r\n\r\n/*\r\n * Instrument state badges and the start/stop button, copied from\r\n * veriform-desktop (custom-bootstrap.scss:1525-1560) so an instrument looks\r\n * the same in both apps.\r\n *\r\n * Desktop composes these with `@extend .fusa-badge`. That name is already\r\n * taken here by an unrelated rule -- uppercase, white, smaller -- so the\r\n * shared properties live on .instrument-badge instead. The values are\r\n * desktop's.\r\n */\r\n:root {\r\n  --blue-900: #223f58;\r\n}\r\n\r\n.instrument-badge,\r\n.running-badge,\r\n.stopped-badge,\r\n.error-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 6px 10px;\r\n  border-radius: 99px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  line-height: 1.2;\r\n  white-space: nowrap;\r\n}\r\n\r\n.running-badge {\r\n  background-color: var(--green-100);\r\n  color: var(--green-700);\r\n}\r\n\r\n.stopped-badge {\r\n  background-color: var(--neutral-100);\r\n  color: var(--neutral-600);\r\n}\r\n\r\n.error-badge {\r\n  background-color: var(--red-100);\r\n  color: var(--red-700);\r\n  text-decoration: underline;\r\n}\r\n\r\n.btn-blue-dark,\r\n.btn-blue-dark:hover {\r\n  background-color: var(--blue-900);\r\n  color: white;\r\n}\r\n\r\n/*\r\n * Horizontal gutter between the sidebar and the page (FUS-233). Pages that\r\n * open with a breadcrumb bar (project pages, for one) are full bleed: the bar\r\n * and the project nav sit flush against the sidebar, so they drop it.\r\n */\r\n.page-gutter {\r\n  padding-inline: 1rem;\r\n}\r\n\r\n.page-gutter:has(.breadcrumb-bar) {\r\n  padding-inline: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
